/**
 * @generated SignedSource<<807415bb856afeeb21496250aa713d0a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetUserTermsAgreedInput = {
  clientMutationId?: string | null | undefined;
};
export type useSetUserTermsAgreedMutation$variables = {
  input: SetUserTermsAgreedInput;
};
export type useSetUserTermsAgreedMutation$data = {
  readonly setUserTermsAgreed: {
    readonly clientMutationId: string | null | undefined;
    readonly user: {
      readonly termsAgreedAt: any | null | undefined;
      readonly updatedAt: any;
    } | null | undefined;
  } | null | undefined;
};
export type useSetUserTermsAgreedMutation = {
  response: useSetUserTermsAgreedMutation$data;
  variables: useSetUserTermsAgreedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "termsAgreedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetUserTermsAgreedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetUserTermsAgreedPayload",
        "kind": "LinkedField",
        "name": "setUserTermsAgreed",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSetUserTermsAgreedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetUserTermsAgreedPayload",
        "kind": "LinkedField",
        "name": "setUserTermsAgreed",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3461edbbf96f7f2116924ed26026cc51",
    "id": null,
    "metadata": {},
    "name": "useSetUserTermsAgreedMutation",
    "operationKind": "mutation",
    "text": "mutation useSetUserTermsAgreedMutation(\n  $input: SetUserTermsAgreedInput!\n) {\n  setUserTermsAgreed(input: $input) {\n    clientMutationId\n    user {\n      termsAgreedAt\n      updatedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e8bd556285f888f0b3e4d303a2e7115";

export default node;
